/* Nova theme JS v5 — Premium DTC */
(function(){
  'use strict';

  document.documentElement.classList.remove('no-js');

  // ============ SCROLL REVEAL (IntersectionObserver) ============
  if ('IntersectionObserver' in window) {
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px -50px 0px' });

    document.querySelectorAll('.reveal, .reveal-stagger').forEach(el => revealObserver.observe(el));
  } else {
    document.querySelectorAll('.reveal, .reveal-stagger').forEach(el => el.classList.add('is-visible'));
  }

  // ============ MARQUEE SPEED (constant px/sec on every device) ============
  function syncMarquees() {
    document.querySelectorAll('[data-marquee]').forEach(function(root){
      const group = root.querySelector('[data-marquee-group]');
      if (!group) return;
      const width = group.getBoundingClientRect().width;
      if (!width) return;
      const speed = 55; // px per second
      const duration = Math.max(12, Math.min(120, width / speed));
      root.style.setProperty('--marquee-duration', duration.toFixed(2) + 's');
    });
  }
  syncMarquees();
  window.addEventListener('load', syncMarquees);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(syncMarquees).catch(function(){});
  let marqueeTimer;
  window.addEventListener('resize', function(){
    clearTimeout(marqueeTimer);
    marqueeTimer = setTimeout(syncMarquees, 200);
  });



  // ============ ANIMATED COUNTERS ============
  function animateCounter(el) {
    const target = parseFloat(el.dataset.counterTarget || el.textContent.replace(/[^\d.-]/g, '')) || 0;
    const duration = parseInt(el.dataset.counterDuration || 1800, 10);
    const prefix = el.dataset.counterPrefix || '';
    const suffix = el.dataset.counterSuffix || '';
    const decimals = parseInt(el.dataset.counterDecimals || 0, 10);
    const startTime = performance.now();

    function step(now) {
      const elapsed = now - startTime;
      const t = Math.min(elapsed / duration, 1);
      const eased = 1 - Math.pow(1 - t, 3);
      const val = target * eased;
      el.textContent = prefix + val.toFixed(decimals) + suffix;
      if (t < 1) requestAnimationFrame(step);
      else el.textContent = prefix + target.toFixed(decimals) + suffix;
    }
    requestAnimationFrame(step);
  }
  if ('IntersectionObserver' in window) {
    const counterObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          animateCounter(entry.target);
          counterObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.4 });
    document.querySelectorAll('[data-counter]').forEach(el => counterObserver.observe(el));
  }

  // ============ HEADER scroll state ============
  const siteHeader = document.querySelector('.site-header');
  if (siteHeader) {
    const onScroll = () => {
      siteHeader.classList.toggle('is-scrolled', window.scrollY > 20);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ============ MOBILE MENU ============
  const menuToggle = document.querySelector('.menu-toggle');
  const headerNav = document.querySelector('.header-nav');
  if (menuToggle && headerNav) {
    menuToggle.addEventListener('click', () => headerNav.classList.toggle('is-open'));
  }

  // ============ CART DRAWER ============
  const cartDrawer = document.querySelector('.cart-drawer');
  const cartOverlay = document.querySelector('.cart-drawer__overlay');
  const cartTriggers = document.querySelectorAll('[data-cart-trigger]');
  const cartCloseBtn = document.querySelector('.cart-drawer__close');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    if (cartOverlay) cartOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    refreshCart();
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    if (cartOverlay) cartOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  cartTriggers.forEach(t => t.addEventListener('click', (e) => { e.preventDefault(); openCart(); }));
  if (cartCloseBtn) cartCloseBtn.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  function refreshCart() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => { renderCart(cart); updateCartCount(cart.item_count); })
      .catch(() => {});
  }

  function renderCart(cart) {
    const body = document.querySelector('.cart-drawer__body');
    const totalEl = document.querySelector('.cart-drawer__total-amount');
    if (!body) return;
    if (cart.item_count === 0) {
      body.innerHTML = '<div class="cart-empty"><p>Sepetiniz boş.</p><a href="/collections/all" class="btn btn--outline">Alışverişe Devam Et</a></div>';
      if (totalEl) totalEl.textContent = formatMoney(0);
      return;
    }
    body.innerHTML = cart.items.map(item => `
      <div class="cart-item" data-line="${item.key}">
        <div class="cart-item__image"><img src="${item.image || ''}" alt="${item.product_title}"></div>
        <div class="cart-item__info">
          <h4 class="cart-item__title">${item.product_title}</h4>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-item__variant">${item.variant_title}</div>` : ''}
          <div class="cart-item__price">${formatMoney(item.final_line_price)}</div>
          <div style="display:flex;align-items:center;gap:.5rem;margin-top:.5rem;">
            <button class="cart-item__qty-btn" data-action="dec" data-key="${item.key}" style="width:28px;height:28px;border:1px solid #ddd;background:#fff;border-radius:50%;">−</button>
            <span style="font-weight:700;min-width:1.5rem;text-align:center;">${item.quantity}</span>
            <button class="cart-item__qty-btn" data-action="inc" data-key="${item.key}" style="width:28px;height:28px;border:1px solid #ddd;background:#fff;border-radius:50%;">+</button>
            <button class="cart-item__remove" data-key="${item.key}" style="margin-left:auto;background:none;border:0;color:#999;font-size:.85rem;text-decoration:underline;">Kaldır</button>
          </div>
        </div>
      </div>
    `).join('');
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
    body.querySelectorAll('.cart-item__qty-btn').forEach(b => {
      b.addEventListener('click', () => {
        const key = b.dataset.key, action = b.dataset.action;
        const item = cart.items.find(i => i.key === key);
        if (!item) return;
        const newQty = action === 'inc' ? item.quantity + 1 : Math.max(0, item.quantity - 1);
        changeCartLine(key, newQty);
      });
    });
    body.querySelectorAll('.cart-item__remove').forEach(b => b.addEventListener('click', () => changeCartLine(b.dataset.key, 0)));
  }

  function changeCartLine(key, qty) {
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(r => r.json()).then(cart => { renderCart(cart); updateCartCount(cart.item_count); });
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'inline-flex' : 'none';
    });
  }

  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    return amount.replace('.', ',') + ' TL';
  }

  // ============ PRODUCT PAGE ============
  const productForm = document.querySelector('[data-product-form]');
  if (productForm) {

    // Gallery
    document.querySelectorAll('[data-thumb]').forEach(thumb => {
      thumb.addEventListener('click', () => {
        document.querySelector('[data-main-img]').src = thumb.dataset.thumb;
        document.querySelectorAll('[data-thumb]').forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });

    // ============================================================
    // VARIANT SELECTION — bundle-farkında, adet başına bağımsız seçim
    // ============================================================
    // Ürünün varyasyonu varsa (renk, model vb.), seçilen bundle kaç adetse
    // o kadar bağımsız varyasyon seçici üretilir: "1. Ürün", "2. Ürün" ...
    // Her adet kendi rengini/varyasyonunu seçebilir, diğerlerine dokunmaz.
    // ============================================================

    const productRoot = productForm.closest('.product__info') || productForm.parentElement;
    const variantTemplate = productRoot.querySelector('[data-variant-template]');
    const unitsContainer = productRoot.querySelector('[data-variant-units]');
    const unitsWrap = productRoot.querySelector('[data-variant-units-wrap]');
    const variantIdInput = productForm.querySelector('input[name="id"]');
    const variantsData = window.productVariants || [];
    const priceEl = document.querySelector('[data-product-price]');
    const comparePriceEl = document.querySelector('[data-product-compare-price]');
    const atcButton = productForm.querySelector('[data-atc]');
    const atcPriceEl = productForm.querySelector('[data-atc-price]');
    const hasVariantOptions = !!(variantTemplate && unitsContainer);

    // Tek adet bundle fiyatı için kart referansları (bundle modülünde dolduruluyor)
    let activeBundle = { qty: 1, finalCents: null, compareCents: null };
    let units = []; // [{ index, el }]

    // Seçim alanını (heading + adet satırları) o an aktif olan paket kartının
    // İÇİNE taşır. Böylece kullanıcı hangi teklife tıklarsa seçim kutusu
    // hemen onun altında açılmış olur; diğer kartlarda hiçbir şey görünmez.
    function mountUnitsIntoActiveCard() {
      if (!hasVariantOptions || !unitsWrap) return;
      const activeCard = document.querySelector('[data-bundle].is-active');
      if (!activeCard) return;
      activeCard.appendChild(unitsWrap);
      unitsWrap.classList.add('is-visible');
    }

    function getSelectedOptionsIn(root) {
      const groups = root.querySelectorAll('[data-variant-group]');
      const selected = [];
      groups.forEach(group => {
        const pos = parseInt(group.dataset.optionPosition, 10);
        const select = group.querySelector('.uvar__select');
        selected[pos - 1] = select && select.value ? select.value : null;
      });
      return selected;
    }

    function findMatchingVariant(selected) {
      if (variantsData.length === 1) return variantsData[0];
      return variantsData.find(v => {
        if (!v.options || v.options.length !== selected.length) return false;
        return selected.every((val, idx) => val !== null && String(v.options[idx]) === String(val));
      }) || null;
    }

    function getUnitVariant(unitEl) {
      return findMatchingVariant(getSelectedOptionsIn(unitEl));
    }

    // Stoktaki her seçenek kombinasyonunu kontrol eder; tükenmiş/olmayan
    // seçenekleri <select> içinde devre dışı bırakır ve "(Tükendi)" etiketler.
    function updateOptionAvailabilityIn(root) {
      const selected = getSelectedOptionsIn(root);
      root.querySelectorAll('.uvar__select').forEach(select => {
        const pos = parseInt(select.dataset.optionPosition, 10);
        Array.from(select.options).forEach(opt => {
          const probe = selected.slice();
          probe[pos - 1] = opt.value;
          const available = variantsData.some(v => {
            if (!v.options || v.options.length !== probe.length) return false;
            return probe.every((pv, idx) => pv === null || String(v.options[idx]) === String(pv)) && v.available;
          });
          opt.disabled = !available;
          opt.textContent = available ? opt.value : `${opt.value} (Tükendi)`;
        });
      });
    }

    function formatPricing(finalCents, compareCents) {
      if (priceEl) priceEl.textContent = formatMoney(finalCents);
      if (comparePriceEl) {
        if (compareCents && compareCents > finalCents) {
          comparePriceEl.textContent = formatMoney(compareCents);
          comparePriceEl.style.display = '';
        } else {
          comparePriceEl.style.display = 'none';
        }
      }
      if (atcPriceEl) atcPriceEl.textContent = formatMoney(finalCents);
    }

    // Adet rozetini (numara ⇄ hata) ve seçenek stok durumunu günceller
    function updateUnitBadge(unitEl) {
      const badge = unitEl.querySelector('.uvar__badge');
      if (!badge) return;
      const v = getUnitVariant(unitEl);
      badge.classList.toggle('is-error', !v);
    }

    // Tek bir adetin varyasyon durumunu tazele (tükenmiş seçenekler + hata rozeti)
    function refreshUnit(unitEl) {
      updateOptionAvailabilityIn(unitEl);
      updateUnitBadge(unitEl);
      if (getUnitVariant(unitEl)) unitEl.classList.remove('has-error');
    }

    // Eksik seçim yapılmış ilk adedi bulur; tüm adetleri hata durumuna göre işaretler
    function validateUnits() {
      let firstInvalid = null;
      units.forEach(u => {
        const ok = !!getUnitVariant(u.el);
        u.el.classList.toggle('has-error', !ok);
        if (!ok && !firstInvalid) firstInvalid = u.el;
      });
      return firstInvalid;
    }

    // Sepete ekle butonunun altında kısa ömürlü bir uyarı mesajı gösterir
    let formMessageTimer = null;
    function showFormMessage(msg) {
      const el = productForm.querySelector('[data-form-message]');
      if (!el) return;
      el.textContent = msg;
      el.classList.add('is-visible');
      clearTimeout(formMessageTimer);
      formMessageTimer = setTimeout(() => el.classList.remove('is-visible'), 4000);
    }

    // Fiyat + Sepete Ekle butonunun genel durumunu tazele
    function updatePricingAndATC() {
      const qty = hasVariantOptions ? (units.length || 1) : (parseInt(productForm.querySelector('[data-qty]')?.value || 1, 10));

      let allMatched = true;
      let allAvailable = true;
      let firstVariant = null;

      if (hasVariantOptions) {
        units.forEach((u, idx) => {
          const v = getUnitVariant(u.el);
          if (idx === 0) firstVariant = v;
          if (!v) { allMatched = false; allAvailable = false; }
          else if (!v.available) { allAvailable = false; }
        });
      } else {
        firstVariant = variantsData[0] || null;
        if (variantIdInput && firstVariant) variantIdInput.value = firstVariant.id;
        allAvailable = firstVariant ? firstVariant.available : false;
      }

      let finalCents, compareCents;
      if (activeBundle.finalCents) {
        finalCents = activeBundle.finalCents;
        compareCents = activeBundle.compareCents;
      } else if (firstVariant) {
        finalCents = firstVariant.price * qty;
        compareCents = (firstVariant.compare_at_price && firstVariant.compare_at_price > firstVariant.price)
          ? firstVariant.compare_at_price * qty
          : null;
      } else {
        const fallback = variantsData[0];
        finalCents = fallback ? fallback.price * qty : 0;
        compareCents = null;
      }
      formatPricing(finalCents, compareCents);

      if (atcButton) {
        const isAvailable = allMatched && allAvailable;
        atcButton.disabled = !isAvailable;
        const textEl = atcButton.querySelector('.atc-text');
        if (textEl) {
          textEl.textContent = isAvailable
            ? (atcButton.dataset.atcText || 'SEPETE EKLE')
            : (allMatched ? 'TÜKENDİ' : 'LÜTFEN SEÇİM YAPIN');
        }
      }
    }

    // "Tümüne uygula" — 1. ürünün seçimini diğer tüm adetlere kopyalar.
    // Adet sayısı arttıkça tek tek seçim yapma sürtünmesini azaltır.
    function applyFirstUnitToAll() {
      if (units.length < 2) return;
      const sourceSelects = units[0].el.querySelectorAll('.uvar__select');
      const sourceValues = Array.from(sourceSelects).map(s => ({ pos: s.dataset.optionPosition, value: s.value }));
      units.slice(1).forEach(u => {
        sourceValues.forEach(({ pos, value }) => {
          if (!value) return;
          const select = u.el.querySelector(`.uvar__select[data-option-position="${pos}"]`);
          if (select && select.value !== value) {
            select.value = value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });
    }

    // Şablondan bir "adet" varyasyon satırı üretir; select id/name'lerini
    // adete özgü hale getirip diğer adetlerden tamamen izole eder.
    function buildUnit(unitIndex, totalUnits) {
      const wrapper = document.createElement('div');
      wrapper.className = 'uvar__row';
      wrapper.dataset.unit = unitIndex;

      if (totalUnits > 1) {
        const badge = document.createElement('span');
        badge.className = 'uvar__badge';
        badge.textContent = '#' + unitIndex;
        wrapper.appendChild(badge);
      }

      const fieldsWrap = document.createElement('div');
      fieldsWrap.className = 'uvar__fields';

      const clone = variantTemplate.content.cloneNode(true);
      clone.querySelectorAll('.uvar__select').forEach(select => {
        select.id = `u${unitIndex}-opt-${select.dataset.optionPosition}`;
        select.name = `u${unitIndex}-option-${select.dataset.optionPosition}`;
        select.dataset.unit = unitIndex;
      });
      fieldsWrap.appendChild(clone);
      wrapper.appendChild(fieldsWrap);

      wrapper.querySelectorAll('.uvar__select').forEach(select => {
        select.addEventListener('change', () => {
          refreshUnit(wrapper);
          updatePricingAndATC();
        });
        // Dropdown açılırken kartın kendisinin yeniden seçilmesini/kapanmasını tetiklememesi için
        select.addEventListener('click', (e) => e.stopPropagation());
      });

      return wrapper;
    }

    function renderUnits(qty) {
      if (!hasVariantOptions) return;
      unitsContainer.innerHTML = '';
      units = [];
      const safeQty = Math.max(1, qty || 1);

      if (safeQty > 1) {
        const applyRow = document.createElement('button');
        applyRow.type = 'button';
        applyRow.className = 'uvar__apply-all';
        applyRow.textContent = 'Aynı seçimi tüm ürünlere uygula';
        applyRow.addEventListener('click', (e) => { e.stopPropagation(); applyFirstUnitToAll(); });
        unitsContainer.appendChild(applyRow);
      }

      for (let i = 1; i <= safeQty; i++) {
        const unitEl = buildUnit(i, safeQty);
        unitsContainer.appendChild(unitEl);
        units.push({ index: i, el: unitEl });
      }

      units.forEach(u => refreshUnit(u.el));
      updatePricingAndATC();
      mountUnitsIntoActiveCard();
    }

    // Quantity (varyasyonsuz ürünlerde bundle adedi burada tutulur)
    const qtyInput = productForm.querySelector('[data-qty]');

    // ============================================================
    // BUNDLE selector — adet değiştikçe varyasyon seçicileri de yeniden üretilir
    // ve seçim kutusu tıklanan kartın içine taşınır.
    // Kart artık <button> değil <div role="radio">; tıklama sadece kartın
    // üst satırına (.bundle-card__row) bağlı — böylece karta taşınan
    // <select> elemanlarına tıklamak yanlışlıkla kartı yeniden tetiklemez.
    // ============================================================
    function selectBundle(card) {
      document.querySelectorAll('[data-bundle]').forEach(c => {
        c.classList.remove('is-active');
        c.setAttribute('aria-checked', 'false');
      });
      card.classList.add('is-active');
      card.setAttribute('aria-checked', 'true');

      const qty = parseInt(card.dataset.bundle, 10) || 1;
      const finalCents = parseInt(card.dataset.bundleFinal, 10) || null;
      const compareCents = parseInt(card.dataset.bundleCompare, 10) || null;

      activeBundle = { qty, finalCents, compareCents };

      if (qtyInput) qtyInput.value = qty;
      if (hasVariantOptions) {
        renderUnits(qty); // renderUnits, seçim kutusunu bu karta taşımayı da yapar
      } else {
        updatePricingAndATC();
      }
    }

    document.querySelectorAll('[data-bundle]').forEach(card => {
      const row = card.querySelector('.bundle-card__row') || card;
      row.addEventListener('click', () => selectBundle(card));
      card.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          selectBundle(card);
        }
      });
    });

    // İlk aktif bundle kartının adedini/fiyatını yakala
    const initialActiveBundle = document.querySelector('[data-bundle].is-active');
    if (initialActiveBundle) {
      activeBundle = {
        qty: parseInt(initialActiveBundle.dataset.bundle, 10) || 1,
        finalCents: parseInt(initialActiveBundle.dataset.bundleFinal, 10) || null,
        compareCents: parseInt(initialActiveBundle.dataset.bundleCompare, 10) || null
      };
      if (qtyInput) qtyInput.value = activeBundle.qty;
    }

    if (hasVariantOptions) {
      renderUnits(activeBundle.qty);
    } else {
      updatePricingAndATC();
    }

    // ATC submit — varyasyonlu üründe her adet kendi variant id'siyle
    // ayrı bir satır olarak sepete eklenir (quantity: 1 x adet sayısı kadar satır).
    productForm.addEventListener('submit', (e) => {
      e.preventDefault();

      let items = [];
      if (hasVariantOptions) {
        const firstInvalid = validateUnits();
        if (firstInvalid) {
          firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
          firstInvalid.classList.add('shake');
          setTimeout(() => firstInvalid.classList.remove('shake'), 500);
          showFormMessage('Lütfen işaretli ürün(ler) için bir seçim yap.');
          return;
        }
        items = units.map(u => ({ id: getUnitVariant(u.el).id, quantity: 1 }));
      } else {
        const qty = parseInt(qtyInput?.value || activeBundle.qty || 1, 10);
        const id = parseInt(variantIdInput?.value || (variantsData[0] && variantsData[0].id), 10);
        items = [{ id, quantity: qty }];
      }

      atcButton.disabled = true;
      const textEl = atcButton.querySelector('.atc-text');
      const originalText = textEl ? textEl.textContent : atcButton.textContent;
      if (textEl) textEl.textContent = 'EKLENİYOR...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      })
        .then(r => r.json())
        .then(() => {
          if (textEl) textEl.textContent = '✓ SEPETE EKLENDİ';
          setTimeout(() => { atcButton.disabled = false; if (textEl) textEl.textContent = originalText; }, 1500);
          openCart();
        })
        .catch(() => { atcButton.disabled = false; if (textEl) textEl.textContent = originalText; alert('Hata. Tekrar deneyin.'); });
    });
  }

  // ============ STICKY ATC ============
  const stickyAtc = document.querySelector('.sticky-atc');
  if (stickyAtc && productForm) {
    document.body.classList.add('has-sticky-atc');
    const atcButton = productForm.querySelector('[data-atc]');
    const stickyBtn = stickyAtc.querySelector('.sticky-atc__btn');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', (e) => {
        e.preventDefault();
        atcButton?.click();
        atcButton?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
    const heroAtc = productForm.querySelector('[data-atc]');
    if (heroAtc && 'IntersectionObserver' in window) {
      const atcObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          stickyAtc.classList.toggle('is-visible', !entry.isIntersecting);
        });
      }, { threshold: 0 });
      atcObserver.observe(heroAtc);
    }
  }

  // ============ PROMO BANNER CTA → Sepete Ekle alanına kaydır ============
  document.querySelectorAll('[data-scroll-atc]').forEach(btn => {
    btn.addEventListener('click', () => {
      const atc = document.querySelector('[data-atc]');
      if (atc) {
        atc.scrollIntoView({ behavior: 'smooth', block: 'center' });
        atc.classList.add('shake');
        setTimeout(() => atc.classList.remove('shake'), 500);
      }
    });
  });

  // ============ CONTENT TABS ============
  document.querySelectorAll('[data-tabs]').forEach(container => {
    const buttons = container.querySelectorAll('[data-tab-btn]');
    const panes = container.querySelectorAll('[data-tab-pane]');
    buttons.forEach(btn => {
      btn.addEventListener('click', () => {
        buttons.forEach(b => b.classList.remove('is-active'));
        panes.forEach(p => p.classList.remove('is-active'));
        btn.classList.add('is-active');
        const target = container.querySelector(`[data-tab-pane="${btn.dataset.tabBtn}"]`);
        if (target) target.classList.add('is-active');
      });
    });
  });

  // ============ VIDEO POSTER PLAY ============
  document.querySelectorAll('[data-video-poster]').forEach(poster => {
    poster.addEventListener('click', () => {
      const videoId = poster.dataset.videoId;
      const provider = poster.dataset.videoProvider || 'youtube';
      let src = '';
      if (provider === 'youtube') src = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
      else if (provider === 'vimeo') src = `https://player.vimeo.com/video/${videoId}?autoplay=1`;
      const iframe = document.createElement('iframe');
      iframe.src = src;
      iframe.allow = 'autoplay; encrypted-media';
      iframe.allowFullscreen = true;
      poster.parentNode.appendChild(iframe);
      poster.style.display = 'none';
    });
  });

  // ============ Initial cart count ============
  fetch('/cart.js').then(r => r.json()).then(cart => updateCartCount(cart.item_count)).catch(() => {});

})();
